export const tradingBotAddresses = [
  '0x293573115f4819c2c9541DdEc98AFCFF825B41dA',
  '0xB46227Bf3eb2d0A6CCC7D55d1e3e00A049bdD98F',
  '0x78E3a45081e696dA28d6f9c166b320F473D652c6',
];
